'use strict';

const LOCATION_SOURCE = require('./location-source');

/**
 * Resolves buyer postal code with fixed precedence:
 * manual > browser > profile > geo-IP > legacy ZIP.
 *
 * @param {{
 *   cachedLocation?: object|null,
 *   legacyPostalCode?: string|null,
 *   profilePostalCode?: string|null,
 * }} inputs
 * @returns {string}
 */
function resolveBuyerPostalCode(inputs) {
	const cachedLocation = inputs.cachedLocation;
	const hasCachedLocation =
		cachedLocation !== null &&
		cachedLocation !== undefined &&
		typeof cachedLocation === 'object';
	const cachedSource = hasCachedLocation ? cachedLocation.source : null;
	const cachedPostalCode = hasCachedLocation
		? String(cachedLocation.postalCode ?? '').trim()
		: '';

	const candidates = [
		cachedSource === LOCATION_SOURCE.MANUAL ? cachedPostalCode : '',
		cachedSource === LOCATION_SOURCE.BROWSER ? cachedPostalCode : '',
		String(inputs.profilePostalCode ?? '').trim(),
		cachedSource === LOCATION_SOURCE.IP ? cachedPostalCode : '',
		String(inputs.legacyPostalCode ?? '').trim(),
	];

	for (const postalCode of candidates) {
		if (postalCode !== '') {
			return postalCode;
		}
	}

	return '';
}

module.exports = {
	resolveBuyerPostalCode,
};
